import { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";

const SCROLL_THRESHOLD = 200;

/**
 * Button that scrolls the page to top. Shown only when user has scrolled down.
 * Renders as a block in the floating action stack (no fixed positioning).
 */
const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const checkScroll = () => setVisible(window.scrollY > SCROLL_THRESHOLD);
    checkScroll();
    window.addEventListener("scroll", checkScroll, { passive: true });
    return () => window.removeEventListener("scroll", checkScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleClick();
        }
      }}
      aria-label="Remonter en haut de la page"
      className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-white border border-gray-200 text-green-night shadow-md hover:shadow-lg hover:bg-emerald-soft hover:border-green-night/20 transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-night focus-visible:ring-offset-2 touch-manipulation active:scale-[0.97]"
    >
      <ChevronUp className="h-6 w-6" aria-hidden />
    </button>
  );
};

export default ScrollToTopButton;
